export default function () {
  const newAddMaintenanceData = {
    title: '新增在修车辆',
    dataDesc: 'T-1日数据',
    dataUpdateTime: '',
    xAxis: {
      data: [],
    },
    yAxis: {
      axisLabel: {
        show: true,
        interval: 'auto',
        formatter: '{value}',
      },
    },
    legendData: [],
    seriesData: [],
  }

  const totalMaintenanceData = {
    title: '累计在修车辆',
    dataDesc: 'T-1日数据',
    dataUpdateTime: '',
    xAxis: {
      data: [],
    },
    yAxis: {
      axisLabel: {
        show: true,
        interval: 0,
      },
    },
    legendData: [],
    seriesData: [],
  }


  const newAddCitySpread = {
    title: '城市',
    dataDesc: 'T-1日数据',
    dataUpdateTime: '',
    isShowTooltip: false,
    yAxis: {
      type: 'category',
      data: [],
      axisLabel: {
        show: true,
        interval: 0,
        rotate: 30,
      },
    },
    xAxis: {
      type: 'value',
    },
    legendData: [],
    seriesData: [],
  }

  const newAddStoreSpread = {
    title: '门店',
    dataDesc: 'T-1日数据',
    dataUpdateTime: '',
    isShowTooltip: false,
    yAxis: {
      type: 'category',
      data: [],
      axisLabel: {
        show: true,
        interval: 0,
        rotate: 30,
      },
    },
    xAxis: {
      type: 'value',
    },
    legendData: [],
    seriesData: [],
  }


  const curCitySpread = {
    title: '所在城市',
    dataDesc: 'T-1日数据',
    dataUpdateTime: '',
    isShowTooltip: false,
    yAxis: {
      type: 'category',
      data: [],
      axisLabel: {
        show: true,
        interval: 0,
        rotate: 30,
      },
    },
    xAxis: {
      type: 'value',
    },
    legendData: [],
    seriesData: [],
  }

  const curStoreSpread = {
    title: '所在门店',
    dataDesc: 'T-1日数据',
    dataUpdateTime: '',
    isShowTooltip: false,
    yAxis: {
      type: 'category',
      data: [],
      axisLabel: {
        show: true,
        interval: 0,
        rotate: 30,
      },
    },
    xAxis: {
      type: 'value',
    },
    seriesData: [],
  }

  return {
    newAddMaintenanceData,
    totalMaintenanceData,
    newAddCitySpread,
    newAddStoreSpread,
    curCitySpread,
    curStoreSpread,
  }
}
